import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';
//import './lib/readmore';
//import lightbox from 'lightbox2';
import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay]);
//import simpleParallax from 'simple-parallax-js';

import AOS from 'aos';

$(document).foundation();

$(function() {
    $('header a[href*=\\#]:not([href=\\#])').click(function() {
        if (Foundation.MediaQuery.only('small')) {
            $(document.getElementsByTagName('body')).removeClass("fixed");
            $(document.getElementsByTagName('header')).removeClass("fixed");
            $(document.getElementsByClassName('title-bar')).removeClass("open");
            $(document.getElementById('main-nav')).toggle();
        }
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            && location.hostname == this.hostname) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 180//offsets for fixed header
                }, 800);
                return false;
            }
        }
    });
    if($(location.href.split("#")[1])) {
        var target = $('#'+location.href.split("#")[1]);
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - 180 //offset height of header here too.
            }, 800);
            return false;
        }
    }
    $('.spalten a[href*=\\#]:not([href=\\#])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            && location.hostname == this.hostname) {

            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 155//offsets for fixed header
                }, 800);
                return false;
            }
        }
    });
});

/*
lightbox.option({
    albumLabel: 'Bild %1 von %2',
});
*/
$('section').attr({
    'data-aos': 'fade-up',
    'data-duration': 1400,
    'data-mirror': true
});

AOS.init({
    disable: 'mobile',
    //duration: 1000,
    mirror: false,
});

//Menu Icon Switch
$("button.menu-icon").on("click", function () {
    if ($(this).parent().hasClass("open")) {
        $(this).parent().removeClass("open");
    } else {
        $(this).parent().addClass("open");
    }
});


$("button.menu-icon").on("click", function () {
    if ($(document.getElementsByTagName('header')).hasClass("fixed")) {
        $(document.getElementsByTagName('header')).removeClass("fixed");
    } else {
        $(document.getElementsByTagName('header')).addClass("fixed");
    }
});
$("button.menu-icon").on("click", function () {
    if ($(document.getElementsByTagName('body')).hasClass("fixed")) {
        $(document.getElementsByTagName('body')).removeClass("fixed");
    } else {
        $(document.getElementsByTagName('body')).addClass("fixed");
    }
});


//Header Fixed window.innerHeight / 2

$(window).scroll(function() {
    var sticky = $('header'),
        scroll = $(window).scrollTop();

    if (scroll >= (200)) {
        sticky.addClass('fixedscroll'); }
    else if(scroll <= 10) {
        sticky.removeClass('fixedscroll');
    }
});


var carousel = new Swiper(".swiper-testimonials", {
    slidesPerView: 1,
    spaceBetween: 6,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next-testi",
        prevEl: ".swiper-button-prev-testi",
    },
    pagination: {
        el: ".swiper-pagination",
    },

});


var hero = new Swiper(".swiper-hero", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next-hero",
        prevEl: ".swiper-button-prev-hero",
    },
    pagination: {
        el: ".swiper-pagination",
    },
});

/*
jQuery( document ).ready( function( $ ) {
    $('.readmore').readmore({ speed: 1000,collapsedHeight: 0, moreLink: '<a class="readmore-link" href="#">Mehr anzeigen</a>', lessLink: '<a class="less" href="#">Weniger anzeigen</a>' });
});

*/